import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=50841f27&"
var script = {}
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=50841f27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports